/**
 * Example instrument configuration (the Jena NMR instruments) usable as a
 * starting point and for the demo.
 */
export const initialConfig = {
    solventMapping: {
        'acetic acid-d4': 'Acetic',
        'acetone-d6': 'Acetone',
        'acetone, non-deuterated': 'Acetone-H6',
        'benzene-d6': 'C6D6',
        'dichloromethane-d2': 'CD2Cl2',
        'acetonitrile-d3': 'CD3CN',
        'LC-SPE solvent (acetonitrile)': 'CD3CN_SPE',
        'LC-SPE solvent (methanol-d4)': 'CD3OD_SPE',
        'chloroform-d': 'CDCl3',
        '9:1': 'CDCl3+MeOD',
        'dichlormethan, non-deuterated': 'CH2Cl2',
        'acetonitrile, non-deuterated': 'CH3CN',
        'HPLC solvent (acetonitrile/D2O)': 'CH3CN+D2O',
        'methanol, non-deuterated': 'CH3OH',
        'HPLC solvent (methanol/D2O)': 'CH3OH+D2O',
        'chlorobenzene-d5': 'ClBZ',
        'deuterium oxide': 'D2O',
        'deuterium oxide with salt': 'D2O_salt',
        'dioxane-d8': 'Dioxane',
        'N,N-dimethylformamide-d7': 'DMF',
        'dimethyl sulfoxide-d6': 'DMSO',
        'dimethylsulfoxide, non-deuterated': 'DMSO-H6',
        'ethanol-d6': 'EtOD',
        'water, non-deuterated': 'H2O',
        '90:10 H2O:D2O': 'H2O+D2O',
        'dCholinCl in H2O + 10%D2O': 'H2O+D2O+dCholin',
        'dDMSO in H2O/D2O (lock)': 'H2O+D2O+dDMSO',
        'dTris in H2O + 10% D2O (lock)': 'H2O+D2O+dTris',
        '90%H2O and 10%D2O with salt': 'H2O+D2O_salt',
        'dTris (lock) in H2O + 10%D2O': 'H2O+dTris+D2O',
        '90%DMSO and 10%DMSO-d6': 'HDMSO',
        'fruit juice': 'Juice',
        'methanol-d4': 'MeOD',
        '1:3': 'MeOD+CDCl3',
        'methanol-D3': 'MeOH',
        'no solvent': 'None',
        'blood plasma': 'Plasma',
        'pyridine-d5': 'Pyr',
        '(CD3)4NCl in 90% H2O and 10%D20, for NMR thermometer': 'T_H2O+D2O+Me4NCl',
        'sodium acetate in 90% H2O and 10%D20, for NMR thermometer': 'T_H2O+D2O+NaAc',
        'pivalate-d9 in 90% H2O and 10%D20, for NMR thermometer': 'T_H2O+D2O+Pivalate',
        'methanol-d4, for NMR thermometer': 'T_MeOD',
        'trifluoroethanol-d3': 'TFE',
        'tetrahydrofuran-d8': 'THF',
        'tetrahydrofuran, non-deuterated': 'THF-H8',
        'toluene-d8': 'Tol',
        'toluene, non-deuterated': 'Tol-H8',
        urine: 'Urine',
        'o-dichlorobenzene-d4': 'oC6D4Cl2',
        'p-dibromobenzene-d4': 'pC6D4Br2',
    },
    instruments: {
        'n300-zaf': {
            experiments: [
                {
                    requestKey: '1H',
                    isPolymer: false,
                    experiment: '1H_CSE_LL',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '6.5' },
                        { label: 'sw', value: '20' },
                        { label: 'ns', value: '16' },
                        { label: 'ds', value: '2' },
                    ],
                },
                {
                    requestKey: '13C',
                    isPolymer: false,
                    experiment: '13C{1H}_CSE_LL',
                    parameters: [
                        { label: 'd1', value: '1.5' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '110' },
                        { label: 'sw', value: '264' },
                        { label: 'ns', value: '256' },
                        { label: 'ds', value: '2' },
                    ],
                },
                {
                    requestKey: '13C',
                    isPolymer: true,
                    experiment: '13C{1H}_POLYMER',
                    parameters: [
                        { label: 'd1', value: '0.7' },
                        { label: 'td', value: '16k' },
                        { label: 'o1p', value: '115' },
                        { label: 'sw', value: '276' },
                        { label: 'ns', value: '10k' },
                        { label: 'ds', value: '4' },
                    ],
                },
                {
                    requestKey: 'APT',
                    isPolymer: false,
                    experiment: '13C{1H}_APT',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '115' },
                        { label: 'sw', value: '236' },
                        { label: 'ns', value: '1k' },
                        { label: 'ds', value: '4' },
                    ],
                },
                {
                    requestKey: 'DEPT_135',
                    isPolymer: false,
                    experiment: 'DEPT135',
                    parameters: [
                        { label: 'd1', value: '1.5' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '115' },
                        { label: 'sw', value: '276' },
                        { label: 'ns', value: '512' },
                        { label: 'ds', value: '8' },
                    ],
                },
                {
                    requestKey: 'DEPT_135',
                    isPolymer: true,
                    experiment: 'DEPT135_POLYMER',
                    parameters: [
                        { label: 'd1', value: '0.75' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '115' },
                        { label: 'sw', value: '276' },
                        { label: 'ns', value: '2500' },
                        { label: 'ds', value: '8' },
                    ],
                },
                {
                    requestKey: 'COSY',
                    isPolymer: false,
                    experiment: 'COSY_CSE_LL',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '2k' },
                        { label: 'o1p', value: '6.5' },
                        { label: 'sw', value: '15' },
                        { label: 'ns', value: '4' },
                        { label: 'ds', value: '16' },
                    ],
                },
                {
                    requestKey: 'HSQC',
                    isPolymer: false,
                    experiment: 'HSQCed_CSE_LL',
                    parameters: [
                        { label: 'd1', value: '1.4' },
                        { label: 'td', value: '1k' },
                        { label: 'o1p', value: '6.5' },
                        { label: 'sw', value: '16' },
                        { label: 'ns', value: '4' },
                        { label: 'ds', value: '16' },
                        { label: 'cnst2', value: '145' },
                    ],
                },
                {
                    requestKey: 'HMBC',
                    isPolymer: false,
                    experiment: 'HMBC_CSE_LL',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '0' },
                        { label: 'sw', value: '300' },
                        { label: 'ns', value: '256' },
                        { label: 'ds', value: '4' },
                    ],
                },
                {
                    isPolymer: false,
                    experiment: 'TOCSY',
                    parameters: [
                        { label: 'd1', value: '2.5' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '115' },
                        { label: 'sw', value: '282' },
                        { label: 'ns', value: '128' },
                        { label: 'ds', value: '4' },
                    ],
                },
                {
                    isPolymer: false,
                    experiment: 'DOSY_1H',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '0' },
                        { label: 'sw', value: '400' },
                        { label: 'ns', value: '256' },
                        { label: 'ds', value: '4' },
                    ],
                },
                {
                    requestKey: '11B',
                    isPolymer: false,
                    experiment: '11B',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '32k' },
                        { label: 'o1p', value: '0' },
                        { label: 'sw', value: '200' },
                        { label: 'ns', value: '256' },
                        { label: 'ds', value: '4' },
                    ],
                },
                {
                    requestKey: '19F',
                    isPolymer: false,
                    experiment: '19F',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '128k' },
                        { label: 'o1p', value: '-80' },
                        { label: 'sw', value: '242' },
                        { label: 'ns', value: '64' },
                        { label: 'ds', value: '4' },
                    ],
                },
                {
                    requestKey: '19F',
                    isPolymer: false,
                    experiment: '19F{1H}',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '-80' },
                        { label: 'sw', value: '241' },
                        { label: 'ns', value: '64' },
                        { label: 'ds', value: '4' },
                    ],
                },
                {
                    requestKey: '31P',
                    isPolymer: false,
                    experiment: '31P',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '50' },
                        { label: 'sw', value: '514' },
                        { label: 'ns', value: '256' },
                        { label: 'ds', value: '4' },
                    ],
                },
                {
                    requestKey: '31P',
                    isPolymer: false,
                    experiment: '31P{1H}',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '50' },
                        { label: 'sw', value: '514' },
                        { label: 'ns', value: '256' },
                        { label: 'ds', value: '4' },
                    ],
                },
            ],
        },
        'av300-zaf': {
            experiments: [
                {
                    requestKey: '1H',
                    isPolymer: false,
                    experiment: '1H_CSE_LL',
                    parameters: [
                        { label: 'd1', value: '1' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '6.5' },
                        { label: 'sw', value: '20' },
                        { label: 'ns', value: '16' },
                        { label: 'ds', value: '2' },
                    ],
                },
                {
                    requestKey: '13C',
                    isPolymer: false,
                    experiment: '13C{1H}_CSE_LL',
                    parameters: [
                        { label: 'd1', value: '1.5' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '115' },
                        { label: 'sw', value: '260' },
                        { label: 'ns', value: '512' },
                        { label: 'ds', value: '2' },
                    ],
                },
                {
                    requestKey: '13C',
                    isPolymer: true,
                    experiment: '13C_Polymer',
                    parameters: [
                        { label: 'd1', value: '0.7' },
                        { label: 'td', value: '16k' },
                        { label: 'o1p', value: '100' },
                        { label: 'sw', value: '240' },
                        { label: 'ns', value: '10k' },
                        { label: 'ds', value: '4' },
                    ],
                },
                {
                    requestKey: 'APT',
                    isPolymer: false,
                    experiment: 'XXX',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '100' },
                        { label: 'sw', value: '282' },
                        { label: 'ns', value: '256' },
                        { label: 'ds', value: '4' },
                    ],
                },
                {
                    requestKey: 'DEPT_135',
                    isPolymer: false,
                    experiment: '13C_dept135',
                    parameters: [
                        { label: 'd1', value: '1.5' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '100' },
                        { label: 'sw', value: '260' },
                        { label: 'ns', value: '512' },
                        { label: 'ds', value: '4' },
                    ],
                },
                {
                    requestKey: 'DEPT_135',
                    isPolymer: true,
                    experiment: '13C_dept135_Polymer',
                    parameters: [
                        { label: 'd1', value: '0.6' },
                        { label: 'td', value: '16k' },
                        { label: 'o1p', value: '100' },
                        { label: 'sw', value: '240' },
                        { label: 'ns', value: '3k' },
                        { label: 'ds', value: '4' },
                    ],
                },
                {
                    requestKey: 'COSY',
                    isPolymer: false,
                    experiment: 'COSY_CSE_LL',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '2k' },
                        { label: 'o1p', value: '6.5' },
                        { label: 'sw', value: '15' },
                        { label: 'ns', value: '4' },
                        { label: 'ds', value: '16' },
                    ],
                },
                {
                    requestKey: 'HSQC',
                    isPolymer: false,
                    experiment: 'HSQCed_CSE_LL',
                    parameters: [
                        { label: 'd1', value: '1.4' },
                        { label: 'td', value: '1k' },
                        { label: 'o1p', value: '6.5' },
                        { label: 'sw', value: '16' },
                        { label: 'ns', value: '4' },
                        { label: 'ds', value: '16' },
                        { label: 'cnst2', value: '145' },
                    ],
                },
                {
                    requestKey: 'HMBC',
                    isPolymer: false,
                    experiment: 'HMBC_CSE_LL',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '0' },
                        { label: 'sw', value: '300' },
                        { label: 'ns', value: '256' },
                        { label: 'ds', value: '4' },
                    ],
                },
                {
                    requestKey: '19F',
                    isPolymer: false,
                    experiment: '19F',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '-110' },
                        { label: 'sw', value: '200' },
                        { label: 'ns', value: '32' },
                        { label: 'ds', value: '2' },
                    ],
                },
                {
                    requestKey: '19F',
                    isPolymer: false,
                    experiment: '19F{1H}',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '-110' },
                        { label: 'sw', value: '200' },
                        { label: 'ns', value: '32' },
                        { label: 'ds', value: '4' },
                    ],
                },
                {
                    requestKey: '31P',
                    isPolymer: false,
                    experiment: '31P',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '50' },
                        { label: 'sw', value: '512' },
                        { label: 'ns', value: '256' },
                        { label: 'ds', value: '8' },
                    ],
                },
                {
                    requestKey: '31P',
                    isPolymer: false,
                    experiment: '31P{1H}',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '50' },
                        { label: 'sw', value: '512' },
                        { label: 'ns', value: '256' },
                        { label: 'ds', value: '8' },
                    ],
                },
                {
                    requestKey: '1H_water_suppression',
                    isPolymer: false,
                    experiment: '1H_gradsup',
                    parameters: [
                        { label: 'd1', value: '2' },
                        { label: 'td', value: '64k' },
                        { label: 'o1p', value: '4.7' },
                        { label: 'sw', value: '24' },
                        { label: 'ns', value: '32' },
                        { label: 'ds', value: '26' },
                    ],
                },
            ],
        },
    },
};
//# sourceMappingURL=initialConfig.js.map